export default __webpack_public_path__ + "static/media/Background_00107.655cb00a.png";